import { createContext } from "react";
import { ProductType } from "../language/localization";

export type ProductContext = {
  di: number;
  ppi: number;
  productIdToTypeKeyDict: Record<number, ProductType>;
}

export const ProductContext = createContext<ProductContext>({} as ProductContext);